module.exports = __webpack_public_path__ + "lazer4.png?19c9cf3656191a1b3a24072f3ddc6871";